import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chatUserObjects: [],
};

const chatUserObjectsSlice = createSlice({
  name: 'chatUserObjects',
  initialState,
  reducers: {
    setChatUserObjects(state, action) {
      state.chatUserObjects = action.payload;
    },
    updateLayoutByObjectName(state, action) {
      const { objectName, newLayout } = action.payload;
      const index = state.chatUserObjects.findIndex(
        (obj) => obj.name === objectName
      );
      if (index !== -1) {
        state.chatUserObjects[index].layout = newLayout;
      } else {
        // If there's no existing object with that name, create it
        state.chatUserObjects.push({ name: objectName, layout: newLayout });
      }
    },
    updateFieldDetailByName(state, action) {
      const { objectName, fieldName, item, newValue } = action.payload;
    
      const objIndex = state.chatUserObjects.findIndex(
        (obj) => obj.name === objectName
      );
      if (objIndex === -1) {
        console.warn('No object found with name:', objectName);
        return;
      }
    
      // Make sure fields array exists
      if (!Array.isArray(state.chatUserObjects[objIndex].fields)) {
        state.chatUserObjects[objIndex].fields = [];
      }
    
      let fieldIndex = state.chatUserObjects[objIndex].fields.findIndex(
        (f) => f.name === fieldName
      );
    
      // If the field doesn't exist, create it
      if (fieldIndex === -1) {
        state.chatUserObjects[objIndex].fields.push({
          name: fieldName,
          // Initialize these however you want
          aiAutofill: false,
          aiAutofillDetails: {},
        });
        fieldIndex = state.chatUserObjects[objIndex].fields.length - 1;
      }
    
      const fieldRef = state.chatUserObjects[objIndex].fields[fieldIndex];
    
      // If item === 'aiAutofill', just set `fieldRef.aiAutofill = newValue`.
      if (item === 'aiAutofill') {
        fieldRef.aiAutofill = !!newValue;
        return;
      }
    
      // If item starts with 'aiAutofillDetails.', we dig into `fieldRef.aiAutofillDetails`
      if (item.startsWith('aiAutofillDetails.')) {
        const subField = item.replace('aiAutofillDetails.', '');
        if (!fieldRef.aiAutofillDetails) {
          fieldRef.aiAutofillDetails = {};
        }
        if (subField === 'contextFields' && Array.isArray(newValue)) {
          fieldRef.aiAutofillDetails.contextFields = newValue;
        } else {
          fieldRef.aiAutofillDetails[subField] = newValue;
        }
        return;
      }
    
      fieldRef[item] = newValue;
    },
  },
});

export const {
  setChatUserObjects,
  updateLayoutByObjectName,
  updateFieldDetailByName,
} = chatUserObjectsSlice.actions;

export default chatUserObjectsSlice.reducer;